import React from 'react';
import { Select } from 'antd';
import { Button } from '@progress/kendo-react-buttons'
import { Input } from '@progress/kendo-react-inputs';
import services from '../../../services';
import { toast } from 'react-toastify';
import InstructionMessage from '../../VidimaModule/Modal/InstructionMessage';
import { data } from 'jquery';

const { Option } = Select

const message = "Nesta área serão definidas as regras a executar sobre os tipos de movimentos de conta corrente."

class Nivel2TipoMovimento extends React.Component {

  state = {
    filters: {
      Filters: null,
      SortBy: "",
      IsSortTypeDESC: false,
      IsPagination: false,
      Page: 2,
      PageSize: 2
    },
    movemento: [],
    tipoFormulario: [],
    dadosMovimento: [],
    data: {
      "idTipoMovimento": null,
      "idTipoFormulario": null,
      "idproduto": null,
      "idTipoConta": null,
      "comMencao": false,
      "mudaProduto": false,
      "mudaNivel": false,
      "mudaConta": false,
      "deselagem": false,
      "circulaSelado": false,
      "selagem": false,
      "selado": false,
      "geraCobranca": false,
      "alteraTitularidade": false,
      // "calculoCapacidade": false,
      "capacidadeVenda": false,
      "formula": "",
      "descritivoRegra": "",
      "regraCapacidadeMenor": null,
      "regraCapacidadeMaior": null,
      "idTipoContaEntrada": null,
      "idTipoContaSaida": null,
      "idMovimento": null,
      "idMovimentoAssociado": null,
      "idEstado": null,
      "emHistorico": false,
      "movementDecaptiveOrigin": false,
      "movementCaptive": false,
      "movementDecaptiveDestination": false,
      "idFamiliaProdutodestino": null,
      "idFamiliaProdutoOrigim": null,
      "idContaCurrentadestino": null,
      "idContaCurrentaOrigim": null,
      "idMencao": null,
      "idMovimentoTesouraria": null,
      "validaSaldo": false,
      "efetuaCativacao": false,
      "codArtg":"",
      "req_capacidade_onethird" : false,
      "req_capacidade_seventyfive" : false,
      "forSalesCapacityCalculation":  false
    },
    popupadmin: ""
  }

  componentDidMount() {

    (async () => {
      const movemento = await services.apiCall.requestApi("allservice/TipoMovimento/GetAll", this.state.filters, 'post')
      this.setState({ movemento });
    })();

  }

  handleCancel = () => {
    this.props.history.push({
      pathname: "/conta_corrente"
    })
  }

  handleChange = (value, type, id, e) => {
    // const regrasMovimentoForm = this.state.regrasMovimentoForm;

    // regrasMovimentoForm.forEach(elem => { 
    //   if (elem.name == type){
    //     if (value == true){
    //       elem.value = 1;
    //     }
    //     else if (value == false){
    //       elem.value = 0;
    //     }
    //   }
    // });

    // this.setState({ regrasMovimentoForm: regrasMovimentoForm });
  }

  handleChangeTipoMovimento = (e) => {
    //this.setState({ dadosMovimento: [], data: {...this.state.data, "idTipoMovimento": null } });
    const filters = {IDTipoMovimento: e};
    (async () => {
      const dadosMovimento = await services.apiCall.requestApi("RegrasMovimento/GetTipoMovimentoFromID", filters, 'get');
      this.setState({ dadosMovimento, data: {...this.state.data, "idTipoMovimento": e } });
    })();
    
  }

  handleGraver = async () => {

    const sendObj = { 
      IDTipoFormulario: this.state.data.idTipoFormulario,
      IDProduto: this.state.data.idproduto,
      IDTipoConta: this.state.data.idTipoConta,
      MencaoComplementar: this.state.regrasMovimentoForm.find(w => w.name === 'mencaoComplementar').value,
      Granel: this.state.regrasMovimentoForm.find(w => w.name === 'granel').value,
      IndisponivelGranel: this.state.regrasMovimentoForm.find(w => w.name === 'indisponivelGranel').value,
      IndisponivelEngarrafado: this.state.regrasMovimentoForm.find(w => w.name === 'indisponivelEngarrafado').value,
      ProdutoAcabado: this.state.regrasMovimentoForm.find(w => w.name === 'produtoAcabado').value,
      GeraDocumento: this.state.regrasMovimentoForm.find(w => w.name === 'geraDocumento').value,
      CriaConta: this.state.regrasMovimentoForm.find(w => w.name === 'criaConta').value,
      CapacidadeVenda: this.state.regrasMovimentoForm.find(w => w.name === 'capacidadeVenda').value,
      Selagem: this.state.regrasMovimentoForm.find(w => w.name === 'selagem').value,
      CirculaSelado: this.state.regrasMovimentoForm.find(w => w.name === 'circulaSelado').value,
      MudaNivel: this.state.regrasMovimentoForm.find(w => w.name === 'mudaNivel').value,
      ContaSemRegisto: this.state.regrasMovimentoForm.find(w => w.name === 'contaSemRegisto').value,
      ContaSemAno: this.state.regrasMovimentoForm.find(w => w.name === 'contaSemAno').value,
      CobraServico: this.state.regrasMovimentoForm.find(w => w.name === 'cobraServico').value,
      CobraTaxa: this.state.regrasMovimentoForm.find(w => w.name === 'cobraTaxa').value,
      AgendaFiscalizacao: this.state.regrasMovimentoForm.find(w => w.name === 'agendaFiscalizacao').value,
      MovimentoAssociado: this.state.regrasMovimentoForm.find(w => w.name === 'movimentoAssociado').value,
      DesclassificaPara: this.state.regrasMovimentoForm.find(w => w.name === 'desclassificaPara').value,
    }
    console.log("sendObj");
    console.log(sendObj);
    await services.apiCall.requestApi('RegrasMovimento/GravarRegra', sendObj, 'post');
  }

  render() {
 
    const { movemento, dadosMovimento } = this.state
    
    return (
      <div className="container-fluid pb-5">
        <div className="p-3 bg-white border rounded">
          <div>
            <InstructionMessage message={message} messageFor="nivel" />
          </div>
          <label>Tipo de movimento</label>
          <div className="row" id="sticky-seachmenu">
            <div className="col-auto position-relative">
              <Select
                showSearch
                optionFilterProp="children"
                // maxTagTextLength={ 3 }
                placeholder="Selecione o tipo de movimento"
                className="estatoSelect"
                //value={this.state.data.idTipoFormulario}
                onChange={(e) => this.handleChangeTipoMovimento(e)}
                style={{ width: "500px" }}
              >
                <Option disabled >Selecione o tipo de movimento</Option>
                {(movemento && !!movemento.length) && movemento.map((item, index) => (
                  <Option key={index} value={item.idTipoMovimento}>{item.codTipoMovimento} - {item.tipoMovimento}</Option>
                ))}
              </Select>
              <div className="drop-icon">
                <i className="fas fa-chevron-down"></i>
              </div>
            </div>
            <div className="pl-0">
              <Button className="mr-2 btn-ivdp-primary btn-theme k-primary" onClick={() => this.handleGraver()} >Gravar Regra</Button>
            </div>
            <div className="col-auto pl-0">
              <Button className="btn-ivdp-secondary" onClick={() => this.handleCancel()} >Cancelar</Button>
            </div>
          </div>
           
          { dadosMovimento && !!dadosMovimento.length &&
            <>
              {/* <div className="mt-3">
                <h4>Percentagem Capacidade Venda</h4>
                <div className="p-3 border rounded">
                  <div className="row">
                    <div className="col-6">
                        <div> 
                        <input
                            type="number"
                            //name={item.name}
                            //value={this.state.dadosMovimento[0].percentagemCapacidadeVenda}
                            //onChange={(e) => this.handleChange(e.target.checked, e.target.name, item.id, e)}
                            className="input-1 k-textbox"
                            //id={item.name}
                        />
                        </div>
                    </div>
                  </div>
                </div>
              </div> */}
                <div className="row">
                    <div className="col-md-4">
                        <div className="input-box active-grey">
                            <Input
                                type="number"
                                style={{ width: "100%" }}
                                className="input-1"
                                name="pcv"
                                //value={this.state.dadosMovimento[0].percentagemCapacidadeVenda}
                                label="Percentagem Capacidade Venda"
                                //onChange={(e) => this.handleChange(e.target.checked, e.target.name, item.id, e)}
                            />
                        </div>
                    </div>
                    
                </div>
            </>
          }          



        </div>
        
        {
          <div className="modal center" id="popupadmin" >
             <div className="modal-dialog modal-dialog-centered">
              {this.state.popupadmin}
            </div>
          </div>
        }

      </div>
    )
  }

}

export default Nivel2TipoMovimento;